"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TlvState = void 0;
const errors_js_1 = require("./errors.js");
class TlvState {
    constructor(buffer, discriminatorSize = 2, lengthSize = 2, offset = 0) {
        this.tlvData = buffer.subarray(offset);
        this.discriminatorSize = discriminatorSize;
        this.lengthSize = lengthSize;
    }
    /**
     * Get the raw tlv data
     *
     * @return the raw tlv data
     */
    get data() {
        return this.tlvData;
    }
    readEntryLength(size, offset, constructor) {
        switch (size) {
            case 1:
                return constructor(this.tlvData.readUInt8(offset));
            case 2:
                return constructor(this.tlvData.readUInt16LE(offset));
            case 4:
                return constructor(this.tlvData.readUInt32LE(offset));
            case 8:
                return constructor(this.tlvData.readBigUInt64LE(offset));
        }
    }
    /**
     * Get a single entry from the tlv data. This function returns the first entry with the given type.
     *
     * @param type the type of the entry to get
     *
     * @return the entry from the tlv data or null
     */
    firstBytes(discriminator) {
        const entries = this.bytesRepeating(discriminator, 1);
        return entries.length > 0 ? entries[0] : null;
    }
    /**
     * Get a multiple entries from the tlv data. This function returns `count` or less entries with the given type.
     *
     * @param type the type of the entry to get
     * @param count the number of entries to get (0 for all entries)
     *
     * @return the entry from the tlv data or null
     */
    bytesRepeating(discriminator, count = 0) {
        const entries = [];
        let offset = 0;
        while (offset < this.tlvData.length) {
            if (offset + this.discriminatorSize + this.lengthSize > this.tlvData.length) {
                throw new errors_js_1.TlvInvalidAccountDataError();
            }
            const type = this.tlvData.subarray(offset, offset + this.discriminatorSize);
            offset += this.discriminatorSize;
            const entryLength = this.readEntryLength(this.lengthSize, offset, Number);
            offset += this.lengthSize;
            if (offset + entryLength > this.tlvData.length) {
                throw new errors_js_1.TlvInvalidAccountDataError();
            }
            if (type.equals(discriminator)) {
                entries.push(this.tlvData.subarray(offset, offset + entryLength));
            }
            if (count > 0 && entries.length >= count) {
                break;
            }
            offset += entryLength;
        }
        return entries;
    }
    /**
     * Get all the discriminators from the tlv data. This function will return a type multiple times if it occurs multiple times in the tlv data.
     *
     * @return a list of the discriminators.
     */
    discriminators() {
        const discriminators = [];
        let offset = 0;
        while (offset < this.tlvData.length) {
            if (offset + this.discriminatorSize + this.lengthSize > this.tlvData.length) {
                throw new errors_js_1.TlvInvalidAccountDataError();
            }
            const type = this.tlvData.subarray(offset, offset + this.discriminatorSize);
            discriminators.push(type);
            offset += this.discriminatorSize;
            const entryLength = this.readEntryLength(this.lengthSize, offset, Number);
            offset += this.lengthSize;
            if (offset + entryLength > this.tlvData.length) {
                throw new errors_js_1.TlvInvalidAccountDataError();
            }
            offset += entryLength;
        }
        return discriminators;
    }
}
exports.TlvState = TlvState;
//# sourceMappingURL=tlvState.js.map